import React from "react";

import "./App.css";
import RouterPage from "./router/RouterPage";
import Footer from "./layout/footer/Footer";
import { CourseSelectionProvider } from './context/CourseSelectionContext';

function App() {
  return (
    <CourseSelectionProvider>
      <RouterPage />
    </CourseSelectionProvider>
  );
}

export default App;
